import React, { useState } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Chip from "@material-ui/core/Chip";
import TextField from "@material-ui/core/TextField";
import { useDispatch, useSelector } from "react-redux";
import {
  setCorrectAnswerNew,
} from "../../../redux/action/user";
import {
  setEditCorrectAnswer,
} from "../../../redux/action/Edit";
export default function CorrectAnswer(props) {
  // State
  const dispatch = useDispatch();
  const EditState = useSelector((state) => state.Edit);

  const [chosenWord, setChosenWord] = useState([]);

  const [style, setStyle] = useState(
    allanswerFromApi > 0 ? allanswerFromApi : ""
  );
  // functions
  const onChangeHandler = (e, value) => {
    setChosenWord(value);
    props.setCorrectAnswer(value);
    dispatch(setCorrectAnswerNew(value));
    dispatch(setEditCorrectAnswer(value));
    if (props.type) {
    }
  };

  var allanswerFromApi = EditState.edit && EditState.correct_answer ? EditState.correct_answer : undefined;

  const handlechange = (e) => {
    setStyle(e.target.value);
    document
      .querySelector(".placeholder_style_correct")
      .classList.add("beforeEnter");
    if (style === " ") {
      document
        .querySelector(".placeholder_style_correct")
        .classList.add("beforeEnter");
    }
  };

  const onKeyHandler = (event) => {
    if (event.key === "Enter") {
      document
        .querySelector(".placeholder_style_correct")
        .classList.add("afterEnter");
    }
  };

  return (
    <>
      <div className="correct">
        <Autocomplete
          onChange={(e, v) => onChangeHandler(e, v)}
          className="rtl correct w-100"
          multiple
          id="tags-filled"
          defaultValue={allanswerFromApi && allanswerFromApi}
          options={chosenWord && chosenWord.map((option) => option)}
          freeSolo
          renderTags={(chipValue, getTagProps) =>
            chipValue.map((option, index) => (
              <Chip
                variant="outlined"
                label={option}
                {...getTagProps({ index })}
              />
            ))
          }
          autoComplete
          filterSelectedOptions
          renderInput={(params) => (
            <TextField
              className="placeholder_style_correct"
              {...params}
              variant="filled"
              placeholder={"  جواب صحیح را وارد کنید و اینتر را بزنید "}
              filterSelectedOptions
              autoComplete="off"
              onKeyDown={(e) => onKeyHandler(e)}
              onChange={handlechange}
              value={style}
            />
          )}
        />
      </div>
    </>
  );
}
